// Copyright (c) 2017 Deere & Company

import * as actions from '../../actions-list';
import {addRemoveModalClass} from '../../../shared/services/add-remove-modal-class';

export const updatePercentageDebitModalVisibility = visibility =>

    dispatch => {

        addRemoveModalClass(visibility);

        dispatch({
            type: actions.UPDATE_TCSM_PERCENTAGE_DEBIT_MODAL_VISIBILITY,
            visibility
        });

    };



// WEBPACK FOOTER //
// ./src/tcsm/percentage-debit/action-creators/percentage-debit-modal.js